import {GameFeatureFilterDefinitionBase} from "../game-feature-filter-definition-base";
import {GameInfo} from "../../../games/game-info";
import {IGameFilterDefinition} from "../game-filter-definition.interface";
import {HasDailyJackpotFilterDefinition} from "./has-dailight-jackpot.filter-definition";
import {HasTwilightJackpotFilterDefinition} from "./has-twilight-jackpot.filter-definition";
import {HasCaptain8JackpotFilterDefinition} from "./has-captain8-jackpot.filter-definition";
import {HasRedTigerJackpotFilterDefinition} from "./has-red-tiger-jackpot.filter-definition";

export class HasJackpotFilterDefinition extends GameFeatureFilterDefinitionBase {
    get id(): string {
        return "has-jackpot";
    }

    get text(): string {
        return this.services.translation.translate('JACKPOT');
    }

    protected _shouldIncludeGame(gameInfo: GameInfo): boolean {
        return gameInfo.hasJackpot;
    }

    get subFilters(): IGameFilterDefinition[] {
        return [
            new HasDailyJackpotFilterDefinition(this.services),
            new HasTwilightJackpotFilterDefinition(this.services),
            new HasCaptain8JackpotFilterDefinition(this.services),
            new HasRedTigerJackpotFilterDefinition(this.services)
        ]
    }
}